import { getMessage } from '@/commons/services/error';
import getMaxValueByPaymentType from '@/commons/services/getMaxValueByPaymentType';
import TransferValueValidationService from '@transfeeradev/api-services/TransferValueValidationService';

const validate = (value, type) =>
  getMaxValueByPaymentType.get(type).then(maxValue => {
    try {
      new TransferValueValidationService({
        value,
        maxValue
      }).validate();
      return {
        isValid: true
      };
    } catch (error) {
      return {
        isValid: false,
        errorMessage: getMessage(error)
      };
    }
  });

export default {
  validate
};
